module.exports = __webpack_public_path__ + "img/gcards.6641758c.svg";